export const DEFAULT_CITY_ID = 155
export const LOCATION_COOKIE_KEY = 'location'
export const LOCATION_COOKIE_MAX_AGE = 60 * 60 * 24 * 30

export function parseStoredLocation (value) {
  if (!value) {
    return {}
  }

  if (typeof value === 'object') {
    return value
  }

  try {
    return JSON.parse(value)
  } catch (_error) {
    return {}
  }
}

export function getCityIdFromLocation (location, fallback = DEFAULT_CITY_ID) {
  const cityId = location && Number(location.city_id)

  return cityId || fallback
}

export function getStoredLocationFromCookies (cookies) {
  if (!cookies) {
    return {}
  }

  return parseStoredLocation(cookies.get(LOCATION_COOKIE_KEY))
}

export function getStoredLocationFromLocalStorage () {
  if (!process.client || !localStorage.getItem(LOCATION_COOKIE_KEY)) {
    return {}
  }

  return parseStoredLocation(localStorage.getItem(LOCATION_COOKIE_KEY))
}

export function setStoredLocationCookie (cookies, location) {
  if (!cookies || !location || !Object.keys(location).length) {
    return
  }

  cookies.set(LOCATION_COOKIE_KEY, location, {
    maxAge: LOCATION_COOKIE_MAX_AGE,
    path: '/'
  })
}
